import classNames from "classnames";
import type { ComponentPropsWithoutRef } from "react";
import styles from "./Overlay.module.css";

export const Overlay = ({
  active,
  className,
  ...props
}: {
  active: boolean;
  className?: string;
} & ComponentPropsWithoutRef<"div">) => {
  return (
    <div
      className={classNames(
        styles.overlay,
        {
          [styles.active]: active,
        },
        className
      )}
      {...props}
    />
  );
};
